import { useEffect, useState } from 'react';

export const useCountdown = ({ to }: { to?: Date }) => {
  const targetTimestamp = to?.getTime() || Date.now();

  // Time is in seconds
  const [time, setTime] = useState(
    Math.max(0, Math.floor((targetTimestamp - Date.now()) / 1000)),
  );

  const decrement = () =>
    setTime((prevTime) => {
      return prevTime === 0 ? 0 : prevTime - 1;
    });

  useEffect(() => {
    const id = setInterval(decrement, 1000);

    return () => clearInterval(id);
  }, []);

  const format = (num: number): string => {
    return num < 10 ? '0' + num : num.toString();
  };

  const days = format(Math.floor(time / (3600 * 24)));
  const hours = format(Math.floor((time / 3600) % 24));
  const minutes = format(Math.floor((time / 60) % 60));
  const seconds = format(time % 60);

  return {
    days,
    hours,
    minutes,
    seconds,
    str: `${days}d ${hours}h ${minutes}m ${seconds}s`,
    minStr: getMinimumStr({ days, hours, minutes, seconds }),
  };
};

/**
 * to get the minimum string representation of the count down timer
 * @example
 * 00 days 00 hours 00 minutes 03 seconds => 03s
 * 00 days 00 hours 01 minutes 50 seconds => 01m 50s
 */
const getMinimumStr = (count: {
  days: string;
  hours: string;
  minutes: string;
  seconds: string;
}) => {
  return (
    [
      getEmptyStrIfZero(count.days, 'd'),
      getEmptyStrIfZero(count.hours, 'h'),
      getEmptyStrIfZero(count.minutes, 'm'),
      getEmptyStrIfZero(count.seconds, 's'),
    ]
      .filter((v) => !!v)
      .join(' ') || count.seconds + 's'
  );
};

const getEmptyStrIfZero = (num: string, str: string) => {
  return num === '00' ? '' : `${num}${str}`;
};
